@if (spinnerService.buttonSpinnerVisible || spinnerService.spinnerVisible) {
  <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"> </span>
}
